<script>
    export let fill = '#000'
</script>

<style>
    svg#team-top-background {
        position: absolute;
        top: 48px;
        left: 1px;
        width: 413px;
        height: 83.89px;
    }
</style>

<svg id="team-top-background" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 414 83.89">
    <defs>
        <style>
        </style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <rect {fill} width="414" height="83.89" />
        </g>
    </g>
</svg>
